export enum ModalType {
  GROUP_CLOSE = 'GROUP_CLOSE',
  GROUP_CHANGE_FOUNDER = 'GROUP_CHANGE_FOUNDER',
  INVITE_TO_GROUP = 'INVITE_TO_GROUP',
  GIVE_POINTS = 'GIVE_POINTS',
  GIVE_POINTS_SUCCESS = 'GIVE_POINTS_SUCCESS',
  REPORT_PROFILE = 'REPORT_PROFILE',
}
